import { BillStatus, CustRelationChoice, CustSex, isEmpty, isNumberEmpty, OfferType, PayMedium, RateCardType } from "./Constants";
import { TODAY_FORMAT_DATE } from "./DateUtils";

export const SINGLE_CUST_FORM = {
    id: "",
    custPhoto: "",
    custName: "",
    mobNo: "",
    aadharId: "",
    drivingLicense: "",
    panNo: "",
    voterId: "",
    passport: "",
    custDob: "", // keep empty unless provided
    emailId: "",
    address: "",
    custProfession: "",
    custFatherName: "",
    custCompanyName: "",
    custGstDetails: "",
    sex: CustSex.Male,
    relation: "Spoc",
    choice: CustRelationChoice.SPOC,
    index: -1,
};

export const INITIAL_SNP_COMPONENT = {
    showDialog: false,
    outSideClickDismiss: true,
    title: "",
    subTitle: "",
    negativeAction: "",
    positiveAction: "",
    positiveReq: false,
    isLoader: false,
    iconReq: false,
    iconContent: "",
    snackBarOpen: false,
    snackBarMsg: "",
    cancelExtra: false,
    negativeReq: false,
    requestType: 0,
    handleSnpSubmit: null,
    handleSnpCancel: null,
};

export const INITIAL_BILLDATA = {
    roomId: "",
    roomNo: "",
    catgName: "",
    roomBooked: false,
    id: "",
    bookingId: "",
    invoiceId: "",
    totalHotelRoomDetails: [],
    totalHotelRoomDetailsSize: 1,
    restaurantBillIds: [],
    restaurantBillIdsSize: 0,
    listCustomerDetails: [],
    listCustomerDetailsSize: 0,
    salePersonDetails: "",
    takenOffrAmt: 0.0,
    takenDenom: OfferType.No_Offer,
    totalExtraPrice: 0.0,
    totalRoomPrice: 0.0,
    totalRestaurantBillPrice: 0.0,
    totalRestaurantBillPaidPrice: 0.0,
    onlinePay: 0.0,
    cashPay: 0.0,
    payMedium: PayMedium.NOT_SELECTED,
    onlineBillPaidThrough: "",
    pointAdded: 0.0,
    pointRedeem: 0.0,
    roundOff: 0.0,
    cashTendered: 0.0,
    cashReturn: 0.0,
    gstAllowed: true,
    cgst: 2.5,
    sgst: 2.5,
    cgstAmt: 0.0,
    sgstAmt: 0.0,
    totalPrice: 0.0,
    finalPrice: 0.0,
    billStatus: BillStatus.INUI,
    reason: "",
    remarks: "",
    checkInDate: TODAY_FORMAT_DATE,
    checkoutDate: "",
    checkoutMinDate: "",
    lpatialAmt: [],
    duesAmt: 0.0,
    pendingAmt: 0.0,
    priceList: [],
    totalDaysStay: 1,
    paymentInitiated: false,
    paidAmt: 0.0,
    subTotal: 0.0,
    finalCheckoutDate: "",
};

export const SEL_ROOM = {
    id: "", name: "", priceList: [], sel: false,
};

export const SINGLE_ROOM_DATA = {
    id: "", name: "", rateId: "", rateName: "", sAmt: 0.0, extraBedQuan: 0, extraBedPrice: 0.0, totalRoomPrice: 0.0,
    extraBedFullPrice: 0.0, type: RateCardType.HOTEL_NORMAL, mealType: "",
};

export const INITIAL_PARTIAL_PAY = {
    id: "",
    partialAmt: 0.0,
    onlinePay: 0.0,
    cashPay: 0.0,
    payMedium: PayMedium.NOT_SELECTED,
    onlineBillPaidThrough: "",
    paidAcceptBy: "",
    paidOn: "",
    cashTendered: 0.0,
    cashReturn: 0.0,
    remarks: "",
};

export const CHECK_IN_TIME = 1;
export const CHECK_OUT_TIME = 2;

export const normalizeCustomer = (p = {}, opts = {}) => {
    const { spocAdded, keepMob } = opts;
    const defaultChoice = spocAdded
        ? CustRelationChoice.RELATIVE
        : CustRelationChoice.SPOC;
    const choice = p.choice ?? defaultChoice;

    return {
        ...SINGLE_CUST_FORM, // ensure all keys exist with defaults
        ...p, // payload overrides defaults
        mobNo: keepMob ?? p.mobNo ?? "",
        sex: p.sex ?? CustSex.Male,
        choice,
        relation: p.relation ?? (choice === CustRelationChoice.SPOC ? "Spoc" : ""),
        custDob: p.custDob ?? "", // keep empty if not present
        address: p.address ?? "",
        custName: p.custName ?? "",
        aadharId: p.aadharId ?? "",
        emailId: p.emailId ?? "",
        custCompanyName: p.custCompanyName ?? "",
        custGstDetails: p.custGstDetails ?? "",
        custProfession: p.custProfession ?? "",
        custFatherName: p.custFatherName ?? "",
    };
};

export const RoomBoxColour = (data) => {
    if (!isNumberEmpty(data.billStatus)) {
        if (data.billStatus === BillStatus.MODE_ESTIMATION)
            return "#e3ecb1ff";
        else if (data.billStatus === BillStatus.ROOMALLOTEDPARTIALPAID)
            return "#c9aac6";
        else if (data.billStatus === BillStatus.ROOMALLOTEDPAID)
            return "orange";
        else if (data.billStatus === BillStatus.ROOMALLOTEDNOTPAID)
            return "#e26565";
        else if (data.billStatus === BillStatus.ROOMALLOTEDPAIDBUTRESTAURANTNOTPAID)
            return "#e28265";
    }
    return "white";
};

export const GetRommDetsName = (level, data) => {
    if (!data) {
        return "";
    }
    if (level === 1)
        return data.catgName + "(" + data.roomNo + ")";
    else if (level === 2 && !isNumberEmpty(data?.billCount))
        return "Total Bill: " + data.billCount;
    else if (level === 3 && !isEmpty(data.roomType))
        return data.roomType;
    return "";
};